import React, { Component } from 'react';
import { Grid, Row, Jumbotron } from 'react-bootstrap';
import { BrowserRouter as Router, Route } from 'react-router-dom'

import Admin from './page/Admin';
import AdminUser from './page/AdminUser';
import Dashboard from './page/Dashboard';
import Login from './components/Login';
import Header from './components/Header.js'
import TimeOffApplicationForm from './page/TimeOffApplicationForm';
import FormAbsence from './page/FormAbsence';
import UserDetails from './page/UserDetails';
import FormMakeUp from './page/FormMakeUp.js';
import { connect } from 'react-redux';
import { getCurrentUser } from './action';
import './App.css';

const Homepage = ({ match }) => (
  <div className="Homepage">
    <Jumbotron>
      <Grid>
        <h1>Good day!</h1>
        <p>
          Welcome to Roam & Wander's People Ops Page.
          To continue, please login with your Roam and Wander Google account.
        </p>
        <Login />
      </Grid>
    </Jumbotron>
  </div>
)

class App extends Component {

  componentDidMount() {
    this.props.getCurrentUser()
  }

  render() {
    const { user } = this.props;

    return (
      <Router>
        <div className="App">
          <Header />
          { user === undefined
            ? <div />
            : <Grid>
              <Row>
                <Route exact path="/" component={Homepage}/>
                <Route exact path="/admin" component={Admin}/>
                <Route exact path="/admin/user(s?)" component={AdminUser}/>
                <Route exact path="/admin/users/:id" component={UserDetails}/>
                <Route exact path="/dashboard" component={Dashboard}/>
                <Route exact path="/form" component={TimeOffApplicationForm}/>
                <Route exact path="/form/:id" component={TimeOffApplicationForm}/>
                <Route exact path="/absence" component={FormAbsence}/>
                <Route exact path="/makeup" component={FormMakeUp}/>
                <Route exact path="/timeoff"
                  component={(props) => <TimeOffApplicationForm admin {...props} />} />
              </Row>
            </Grid>
          }
        </div>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  const { user, members } = state.auth;
  return { user, members };
};

export default connect(mapStateToProps, { getCurrentUser })(App);



// WEBPACK FOOTER //
// ./src/App.js